import { Grid, GridProps, Typography, TypographyProps } from "@mui/material";
import {
  UseFieldHookProps,
  useField,
  transformDependentFieldsState,
} from "packages/form";
import { FC, Fragment, useEffect } from "react";

export interface AllTypographyProps {
  TypographyProps?: TypographyProps;
  GridProps?: GridProps;
  name: string;
  label: string;
  fieldKey: string;
  setValueOnDependentFieldsChange?: Function;
  componentType?: string;
}

export type MyTypographyAllProps = UseFieldHookProps & AllTypographyProps;

const MyTypography: FC<MyTypographyAllProps> = ({
  name: fieldName,
  fieldKey: fieldID,
  TypographyProps,
  GridProps,
  label,
  dependentFields,
  shouldExclude,
  setValueOnDependentFieldsChange,
  componentType,
}) => {
  const {
    value,
    handleChange,
    name,
    excluded,
    dependentValues,
    incomingMessage,
  } = useField({
    name: fieldName,
    fieldKey: fieldID,
    dependentFields,
    shouldExclude,
    componentType,
  });

  useEffect(() => {
    if (typeof setValueOnDependentFieldsChange === "function") {
      let result = setValueOnDependentFieldsChange(
        transformDependentFieldsState(dependentValues),
      );
      if (result !== undefined && result !== null) {
        handleChange(result);
      }
    }
  }, [dependentValues, handleChange, setValueOnDependentFieldsChange]);

  useEffect(() => {
    if (incomingMessage !== null && typeof incomingMessage === "object") {
      const { value } = incomingMessage;

      if (Boolean(value) || value === "") {
        handleChange(value);
      }
    }
  }, [incomingMessage, handleChange]);

  if (excluded) {
    return null;
  }
  return (
    <Fragment key={name}>
      <Grid {...GridProps}>
        <Typography variant="h6" style={undefined} {...TypographyProps}>
          {value || label}
        </Typography>
      </Grid>
    </Fragment>
  );
};

export default MyTypography;
